import React from 'react';
import cx from 'classnames';

import styles from './Range.module.scss';

export interface Props {
  // classname for range container
  className?: string;
  // classname for range input element
  inputClassName?: string;
  // custom inline style for container
  style?: any;
  // custom inline style for input
  inputStyle?: any;
  // optional range min value
  min?: number;
  // optional range max value
  max?: number;
  // optional range value granularity
  step?: number;
  // optional boolean to disable input
  disabled?: boolean;
  // optional icon component
  Icon?: React.FC<any>;
  // controlled input value
  value: any;
  // handler for change event
  onChange: (e: React.SyntheticEvent) => any;
}

export default function Range({
  className = '',
  inputClassName = '',
  style = {},
  inputStyle = {},
  min = 0,
  max = 100,
  step,
  disabled,
  Icon,
  value,
  onChange,
}: Props) {
  const handleChange = (e: any) => {
    if (disabled) return;
    onChange(e.target.value);
  };

  return (
    <div
      className={cx(styles.rangeWrap, {
        [styles.disabled]: disabled,
        [className]: !!className,
      })}
      style={{ ...style }}
    >
      {Icon ? (
        <div className={styles.iconWrap}>
          <Icon width={14} height={14} />
        </div>
      ) : null}
      <input
        type="range"
        className={cx(styles.rangeInput, {
          [inputClassName]: !!inputClassName,
        })}
        style={{ ...inputStyle }}
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={handleChange}
        disabled={disabled}
      />
      {Icon ? (
        <div className={styles.iconWrap}>
          <Icon width={18} height={18} />
        </div>
      ) : null}
    </div>
  );
}
